import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import stylePropType from 'react-style-proptype';

const DividerWrapper = styled.div`
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;

  padding: ${({ $vertical, $padding }) => ($vertical ? `0 ${$padding}px` : `${$padding}px 0`)};
  width: ${({ $vertical, $thickness }) => ($vertical ? $thickness : '100%')};
  height: ${({ $vertical, $thickness }) => ($vertical ? '100%' : $thickness)};
`;

const DividerLine = styled.hr`
  border: 0;
  margin: 0;
  display: flex;
  flex-shrink: 0;

  border-radius: ${({ $borderRadius }) => $borderRadius || '0px'};
  background: ${({ $color }) => $color || 'var(--border-default)'};

  width: ${({ $vertical, $thickness }) => ($vertical ? $thickness : '100%')};
  height: ${({ $vertical, $thickness }) => ($vertical ? '100%' : $thickness)};
`;

const DividerLabel = styled.span`
  padding: 0 10px;

  font-family: var(--font-family-body);
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;

  color: var(--content-body);
  background: ${({ $background }) => $background || 'var(--white)'};

  position: absolute;
  left: 50%;
  transform: ${({ $thickness }) => `translate3d(-50%, calc(-50% - ${$thickness}), 0)`};
`;

const Divider = ({
  className = null,
  thickness = '1px',
  background = null,
  color = null,
  vertical = false,
  label = null,
  padding = 20,
  borderRadius = '0',
  style = null,
  lineStyle = null,
  onClick = null
}) => (
  <DividerWrapper
    className={className}
    $vertical={vertical}
    $padding={padding}
    style={style}
    $thickness={thickness}
    onClick={onClick}
  >
    <DividerLine
      style={lineStyle}
      $vertical={vertical}
      $color={color}
      $thickness={thickness}
      $borderRadius={borderRadius}
    />
    {label && (
      <DividerLabel $background={background} $thickness={thickness}>
        {label}
      </DividerLabel>
    )}
  </DividerWrapper>
);

Divider.propTypes = {
  className: PropTypes.string,
  thickness: PropTypes.string,
  background: PropTypes.string,
  color: PropTypes.string,
  vertical: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  borderRadius: PropTypes.string,
  style: stylePropType,
  lineStyle: stylePropType,
  onClick: PropTypes.func
};

export { Divider };
